'use strict';

var React = require('react');
var index = require('../Flex/index.js');
var component = require('../Portal/component.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Toaster = React.forwardRef(({ target = globalThis.document?.body, children, position = 'fixed', top, ...props }, ref) => (React__default.default.createElement(component.Portal, { target: target },
    React__default.default.createElement(styles.Styled.Toaster, { ...props, ref: ref, top: top, position: position },
        React__default.default.createElement(index.Flex.Column, { space: "s" }, children)))));

exports.Toaster = Toaster;
//# sourceMappingURL=Toaster.js.map
